window.Sidebar = {
    
    el: null,

    init: function(){
        
        sidebar = this.getEl();
        if (sidebar.length > 0){

            var menu        = $('#menu');
            var contentDiv  = $('#contentDiv');

            if (sidebar.find('.filter-group').length > 0){

                menu.addClass('menuWithoutText');

                if(sidebar.hasClass('closed')){
                    contentDiv.addClass('has-sidebar-closed');
                }else{
                    contentDiv.addClass('has-sidebar-open');
                }

                sidebar.find('.sidebar-toggle').on('click', function(){
                    Sidebar.toggle();
                });

                this.resizeNanoScroll();
                $(window).resize(_.debounce(this.resizeNanoScroll.bind(this), 500));
                
            }else {

                menu.addClass('menuWithoutText');
                $('.listingFilterFormatted a').remove();
                contentDiv.addClass('has-sidebar-closed');
                contentDiv.removeClass('has-sidebar-open');
                sidebar.addClass('closed');
            }
        }
    },
    
    /**
     * @returns {jQuery} Sidebar in DOM
     */
    getEl: function(){

        if(this.el === null){
            this.el = $('.sidebar');
        }

        return this.el;
    },

    resizeNanoScroll: function(){

        var sidebar     = this.getEl();
        var filterTools = $('.filter-tools', sidebar);

        sidebar.find('.nano').height(sidebar.height() - filterTools.outerHeight() - parseInt(filterTools.css('margin-top'), 10) - parseInt(filterTools.css('margin-bottom'), 10));
    },

    toggle : function(){

        var sidebar = this.getEl();
        if(sidebar.length > 0){

            $('#contentDiv')
                .toggleClass('has-sidebar-closed')
                .toggleClass('has-sidebar-open');

            sidebar.toggleClass('closed');
        }
    },

    toggleMenu: function (){
        $("#menu").toggleClass("menuWithoutText");
        $("#contentDiv").toggleClass("has-sidebar-closed");
    }
};